import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPasswordSuccess = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 120,
	height: 120,
	fill: "none",
	viewBox: "0 0 120 120",
	ref,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "pet__Group 1535",
		children: [/* @__PURE__ */ _jsx("circle", {
			id: "pet__Ellipse 1",
			cx: 60,
			cy: 60,
			r: 60,
			fill: props.color
		}), /* @__PURE__ */ _jsxs("g", {
			id: "pet__Group 1534",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "pet__Vector",
				fill: "white",
				d: "M82.1478 90.9097C77.5469 90.9097 73.3461 88.5092 71.0456 84.5084C68.7452 80.5577 68.7452 75.7067 71.0456 71.7059C73.3461 67.7552 77.5469 65.3047 82.1478 65.3047C86.6987 65.3047 90.8995 67.7552 93.1999 71.7059C95.5004 75.7067 95.5004 80.5577 93.1999 84.5084C90.8995 88.5092 86.6987 90.9097 82.1478 90.9097ZM87.7989 75.7567H87.7489C88.249 75.3066 88.249 74.5565 87.7489 74.0564C87.2988 73.6063 86.5487 73.6063 86.0986 74.0564L80.5475 79.6575L78.197 77.307C77.6969 76.8069 76.9468 76.8069 76.4967 77.307C75.9966 77.7571 75.9966 78.5073 76.4967 78.9573L79.6973 82.158C80.1474 82.6581 80.8976 82.6581 81.3977 82.158L87.7989 75.7567Z"
			}), /* @__PURE__ */ _jsx("path", {
				id: "pet__Subtract",
				fill: "white",
				fillRule: "evenodd",
				d: "M56.3636 26C47.3262 26 40 33.3262 40 42.3636V46.3623H34C31.7909 46.3623 30 48.1532 30 50.3623V80.5441C30 82.7533 31.7909 84.5441 34 84.5441H67.8565C66.9688 82.5804 66.4746 80.4006 66.4746 78.1055C66.4746 69.4636 73.4802 62.458 82.1221 62.458C82.3247 62.458 82.5265 62.4619 82.7273 62.4695V50.3623C82.7273 48.1532 80.9364 46.3623 78.7273 46.3623H72.7273V42.3636C72.7273 33.3263 65.401 26 56.3636 26ZM69 42.5V46.3623H44V42.5C44 35.5964 49.5964 30 56.5 30C63.4036 30 69 35.5964 69 42.5ZM57.9219 66.4527C59.4857 65.8504 60.5953 64.3335 60.5953 62.5574C60.5953 60.2529 58.7272 58.3848 56.4227 58.3848C54.1182 58.3848 52.25 60.2529 52.25 62.5574C52.25 64.3329 53.3589 65.8494 54.9219 66.4521V72.9873V74.4873H57.9219V72.9873V66.4527Z",
				clipRule: "evenodd"
			})]
		})]
	})
});
const ForwardRef = forwardRef(SvgPasswordSuccess);
export default ForwardRef;
